import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface AuthState {
    isLogin: boolean;
    token: string;
    setToken: ( token: string ) => void;
    authTopic: Record<string, number[]>;
    setTopic: ( topic: Record<string, number[]> ) => void;
    topicEvents: any[];
    setTopicEvents: ( events: any[] ) => void;
    clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
    devtools(
        persist( ( set ) => ( {
            isLogin: false,
            token: "",
            authTopic: {},
            topicEvents: [],
            setToken: ( token ) => set( { token, isLogin: !!token } ),
            setTopic: ( authTopic ) => set( { authTopic } ),
            setTopicEvents: ( topicEvents ) => set( { topicEvents } ),
            clearAuth: () =>
                set( {
                    //
                    token: "",
                    isLogin: false,
                    authTopic: {},
                    topicEvents: [],
                } ),
        } ), { name: "auth" } ),
        { name: "AuthStore", enabled: process.env.NODE_ENV === "development" },
    ),
);

export const getToken = () => useAuthStore.getState().token;
export const getAuthTopic = ( userId: number ) => {
    return useAuthStore.getState().authTopic[userId] || [];
};
export const isLogin = () => useAuthStore.getState().isLogin;
